import React, { useEffect, useState, useRef, useCallback } from "react";
import { useParallax } from "react-scroll-parallax";
import HomepageBanners from "./homepage-banner.js";
import BannerActionCard from "../cards/action-card/link-action-card-sub";
import { useNavigate } from "react-router";
import { getDataFromCmsApi } from "../../api/contentful-service.js";

const Banner = () => {
    const welcome = useParallax({ scale: [1, 0.9, "easeInQuad"] });
    const alert = useParallax({ scale: [0.9, 1, "easeInQuad"] });
    const navigate = useNavigate();
    const [services, setServices] = useState([]);
    const [atcInformation, setAtcInformation] = useState();
    const textContainerRef = useRef(null);
    const [textContainerHeight, setTextContainerHeight] = useState(0);
    const welcomeAtcInnerRef = useRef(null);
    const [welcomeAtcInnerWidth, setWelcomeAtcInnerWidth] = useState(0);
    const imageRef = useRef(null);
    const [imageLoaded, setImageLoaded] = useState(false);

    const getData = useCallback(async () => {
        const welcomeServicesResult = await getDataFromCmsApi(`Collection/Welcome Services`);
        setServices(welcomeServicesResult);
        const teamMembersData = await getDataFromCmsApi("TeamMember/ADM");
        const atcMemeber = teamMembersData.find(
            (item) => item.position === "Auditor-Controller/Treasurer/Tax Collector"
        );
        setAtcInformation(atcMemeber);
    }, []);

    useEffect(() => {
        getData();
    }, [getData]);

    useEffect(() => {
        const updateTextContainerHeight = () => {
            if (textContainerRef.current) {
                setTextContainerHeight(textContainerRef.current.offsetHeight);
            }
        };

        updateTextContainerHeight();
        window.addEventListener("resize", updateTextContainerHeight);
        return () => {
            window.removeEventListener("resize", updateTextContainerHeight);
        };
    }, []);

    useEffect(() => {
        const updateWelcomeAtcInnerWidth = () => {
            if (welcomeAtcInnerRef.current) {
                setWelcomeAtcInnerWidth(welcomeAtcInnerRef.current.offsetWidth);
            }
        };

        if (welcomeAtcInnerRef.current && imageLoaded) {
            updateWelcomeAtcInnerWidth();
        }

        window.addEventListener("resize", updateWelcomeAtcInnerWidth);

        return () => {
            window.removeEventListener("resize", updateWelcomeAtcInnerWidth);
        };
    }, [imageLoaded]);

    const handleImageLoad = () => {
        setImageLoaded(true);
    };

    return (
        <div className="banner">
            <div className="banner-wrapper">
                <div ref={welcome.ref} className="welcome-atc container">
                    <div className="welcome-atc-inner" ref={welcomeAtcInnerRef}>
                        {atcInformation && atcInformation.imageUrl && (
                            <div className="image-container">
                                <img
                                    ref={imageRef}
                                    src={atcInformation.imageUrl}
                                    alt={atcInformation.position}
                                    className="atc-img img-fluid"
                                    onLoad={handleImageLoad}
                                    style={{
                                        maxHeight: `${textContainerHeight}px`,
                                        maxWidth: `${textContainerHeight}px`,
                                        objectFit: "contain",
                                        transform: "scaleX(-1)"
                                    }}
                                />
                            </div>
                        )}
                        <div className="text-container" ref={textContainerRef}>
                            <div className="welcome">Welcome</div>
                            <div className="atc">To the Auditor-Controller/ Treasurer/ Tax Collector</div>
                        </div>
                    </div>
                </div>

                <div className="alerts container pb-5" ref={alert.ref}>
                    {services.items && services.items.length > 0 && (
                        <div className="d-flex flex-column align-items-center">
                            <div
                                className="grid-container grid-style-2 gap-4"
                                style={{ maxWidth: welcomeAtcInnerWidth }}
                            >
                                {services.items.map((tile, i) => (
                                    <div key={i}>
                                        <BannerActionCard
                                            title={tile.serviceLabel}
                                            handleClick={() => navigate(tile.link)}
                                            iconUrl={tile.iconUrl}
                                            style={{
                                                flexGrow: 1
                                            }}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                    <div
                        className="pt-5 py-md-5"
                        style={{
                            width: welcomeAtcInnerWidth,
                            maxWidth: welcomeAtcInnerWidth,
                            justifySelf: "center"
                        }}
                    >
                        <HomepageBanners />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Banner;
